import { useGame } from 'contexts/Game/Game';
import { useEffect, useMemo } from 'react';
import * as setup from 'setup';
import { useLocalStorage } from 'usehooks-ts';
import Image from '../Image/Image';
import { Container } from './ResultImage.styled';

export default function ResultImage() {
    const [result, setResult] = useLocalStorage<GameResult | null>('sp.resultImage.result', null);
    const game = useGame();

    useEffect(() => {
        if (game.resultType) {
            setResult(setup.game.results[game.resultType]);
        }
    }, [game.resultType, setResult]);

    const visible = useMemo(() => {
        return !!game.resultType;
    }, [game.resultType]);

    return (
        <Container aria-hidden={!visible} $visible={visible}>
            <Image alt={`${result?.title || 'Result'} icon`} src={result?.icon} />
        </Container>
    );
}
